import { Component, OnInit } from '@angular/core';
import { Router, ActivationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss']
})
export class SideMenuComponent implements OnInit {
  show = false;

  constructor(private router: Router) { }

  ngOnInit() {
    this.router.events.pipe(filter(e => e instanceof ActivationEnd)).subscribe(e => this.show = false );
  }

  toggle() {
    this.show = !this.show;
  }
}
